<template>
  <section id="enterprise" class="enterprise">
    <div class="container">
      <h2>加恒科技 · 企业级能力</h2>
      <p class="lead">面向智能设备与企业数字化的端到端交付与合规方案。</p>
      <div class="grid">
        <div class="card">
          <h3>Managed Google Play</h3>
          <p>私有应用分发、版本灰度与按组织单位精准投放，支持内测与托管配置。</p>
        </div>
        <div class="card">
          <h3>Play Integrity</h3>
          <p>集成 Play Integrity API 进行设备与用户完整性校验，减少滥用与欺诈。</p>
        </div>
        <div class="card">
          <h3>EMM / AMAPI</h3>
          <p>支持 Android Management API 与主流 EMM，对接企业策略、应用强制与遥测。</p>
        </div>
        <div class="card">
          <h3>零接触部署</h3>
          <p>兼容 Zero-touch enrollment，开箱即配，批量交付更高效、更安全。</p>
        </div>
        <div class="card">
          <h3>安全与合规</h3>
          <p>数据分域与最小化采集，支持 GDPR/CCPA，提供合规材料与审计轨迹。</p>
        </div>
        <div class="card">
          <h3>企业支持</h3>
          <p>7×24 技术响应、专属顾问与联合排障，覆盖发布、运营与增长全周期。</p>
        </div>
      </div>
      <div class="cta">
        <a href="#pricing" class="btn primary">了解企业版</a>
        <a href="#faq" class="btn">查看常见问题</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Enterprise'
}
</script>

<style scoped>
.enterprise {
  padding: 64px 16px;
  background: #0b1020;
  color: #e5e7eb;
}
.container {
  max-width: 1100px;
  margin: 0 auto;
}
h2 {
  text-align: center;
  margin: 0 0 8px;
}
.lead {
  text-align: center;
  color: #cbd5e1;
  margin: 0 0 24px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.card {
  background: #111827;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 18px;
}
.card h3 {
  margin: 0 0 8px;
  color: #f3f4f6;
}
.cta {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
}
.btn {
  padding: 10px 16px;
  border-radius: 8px;
  color: #e5e7eb;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.primary {
  background: #22c55e;
  border-color: #22c55e;
  color: #0b1020;
}
@media (max-width: 900px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>



